import { useEffect } from 'react'
import { formatRelative } from '../../lib/dates'

export function ThreadPicker({
  threads, activeId, onPick, onClose,
}: {
  threads: any[]
  activeId?: string
  onPick: (id: string) => void
  onClose: () => void
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <>
      <div className="picker-scrim" onClick={onClose} role="presentation" />
      <div className="picker" role="listbox" aria-label="Threads">
        {threads.length === 0 && <p className="picker-empty">No threads yet</p>}
        {threads.map((t) => (
          <button
            key={t._id}
            className={`picker-item${t._id === activeId ? ' is-active' : ''}`}
            role="option"
            aria-selected={t._id === activeId}
            onClick={() => onPick(t._id)}
          >
            <span className="picker-item-title">{t.title}</span>
            <span className="picker-item-meta">
              {t.artifactId ? 'About a game in the Playroom · ' : ''}
              {t.state ? t.state : formatRelative(t.lastMessageAt ?? t.updatedAt)}
            </span>
          </button>
        ))}
      </div>
    </>
  )
}
